
import {observable} from "mobx";
import { PDFControlBaseOptions} from "InternalShared/PageBuilder/Controls/Core/PDFControlBase.Options";
import {ControlTypeEnum} from "PageBuilder/pagebuilder/Controls/NormalPDFControlFactory";
import {PRControlTypes} from "../PRControlFactory";




export class HtmlControlOptions extends PDFControlBaseOptions{
    @observable
    Type:PRControlTypes.HTML;
    @observable
    HTML:string;

    protected LoadDefaultValues() {
        super.LoadDefaultValues();
        this.HTML='<p>Your html goes here</p>';
        this.Type=PRControlTypes.HTML;
        this.Styles.Width='100px';
        this.Styles.Height='100px';
        this.HideFromTemplateDesigner=true;

    }
}